<template>
    <div class="container">
        <div class="container-main">
            <div class="info card">
                <h4 class="card-title bd-bottom">
                    <span class="square"></span>
                    <i class="text">{{ $t('basicInfo') }}</i>
                </h4>
                <div class="card-content">
                    <el-form :model="formData"
                             size="mini"
                             :rules="rules"
                             ref="ruleForm"
                             label-width="110px">
                        <el-form-item :label="$t('roleName')"
                                      prop="name">
                            <el-input v-model="formData.name"
                                      autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('whetherEnable')"
                                      prop="enabled">
                            <el-switch v-model="formData.enabled"
                                       active-color="#13ce66"
                                       inactive-color="#dcdfe6">
                            </el-switch>
                        </el-form-item>
                        <el-form-item :label="$t('remark')"
                                      prop="remark">
                            <el-input type="textarea"
                                      :rows="3"
                                      :placeholder="$t('pleaseInputHint')"
                                      v-model="formData.remark">
                            </el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="permission card">
                <h4 class="card-title bd-bottom">
                    <span class="square"></span>
                    <i class="text">{{ $t('permissionSet') }}</i>
                </h4>
                <div class="card-content">
                    <el-tree :data="permData"
                             node-key="id"
                             ref="tree"
                             show-checkbox
                             check-on-click-node
                             :props="defaultProps">
                    </el-tree>
                </div>
            </div>
        </div>
        <div class="container-footer">
            <div class="handle">
                <el-button size="mini"
                           @click="goBackHandle()">{{ $t('goBack') }}</el-button>
                <el-button type="primary"
                           size="mini"
                           @click="submitForm('ruleForm')">{{ $t('save') }}</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { createRole, queryPermissionTree, queryRoleDetails, updateRole } from "@/api/modules/user";

export default {
    name: "RoleHandle",
    // 组件
    components: {},
    props: {},
    data () {
        return {
            formData: {
                name: '',
                enabled: true,
                remark: ''
            },
            rules: {
                name: [{ required: true, message: this.$t('pleaseInputHint'), trigger: 'blur' }],
                enabled: [{ required: true, message: this.$t('pleaseSelectHint'), trigger: 'change' }],
            },
            permData: [],
            defaultProps: {
                children: 'children',
                label: 'name'
            },
        };
    },
    // 计算属性
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        // 获取权限树
        getPermissionTree () {
            queryPermissionTree().then(res => {
                if (Number(res.code) === 20000) {
                    this.permData = res.data
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch(err => {
                this.$message.error(err)
            })
        },
        // 获取详情
        getDetails () {
            queryRoleDetails(this.$route.query.id).then((res) => {
                if (Number(res.code) === 20000) {
                    let resData = res.data
                    this.formData = {
                        name: resData.name,
                        enabled: resData.enabled,
                        remark: resData.remark
                    }
                    this.permData = resData.perms
                    this.$nextTick(() => {
                        this.disposeTreeChecked(resData.perms)
                    })
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch((err) => {
                this.$message.error(err);
            });
        },
        // 处理默认选中权限
        disposeTreeChecked (data) {
            data.forEach(item => {
                if (item.checked) {
                    this.$refs.tree.setChecked(item.id, true, false)
                }
                if (item.children instanceof Array && item.children.length > 0) {
                    this.disposeTreeChecked(item.children)
                }
            })
        },
        // 验证表单
        submitForm (formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.$route.query.id) {
                        // 编辑
                        this.sendEditRequest()
                    } else {
                        // 添加
                        this.sendAddRequest()
                    }
                } else {
                    return false
                }
            })
        },
        // 重置表单
        resetForm (formName) {
            this.$refs[formName].resetFields()
        },
        // 提交（添加）
        sendAddRequest () {
            // 权限
            let checkedNodes = this.$refs.tree.getCheckedNodes(false, true)
            if (checkedNodes.length === 0) {
                this.$message({
                    showClose: true,
                    message: this.$t('permSelectHint'),
                    type: 'warning'
                })
                return
            }
            let permsIds = checkedNodes.map(item => {
                return item.id
            })
            const params = {
                name: this.formData.name.trim(),
                enabled: this.formData.enabled,
                remark: this.formData.remark,
                permsIds
            }
            this.disabled = true;
            createRole(params).then((res) => {
                this.disabled = false;
                if (Number(res.code) === 20000) {
                    // 返回
                    this.goBackHandle()
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch((err) => {
                this.disabled = false;
                this.$message.error(err);
            });
        },
        // 提交（编辑）
        sendEditRequest () {
            // 权限
            let checkedNodes = this.$refs.tree.getCheckedNodes(false, true)
            if (checkedNodes.length === 0) {
                this.$message({
                    showClose: true,
                    message: this.$t('permSelectHint'),
                    type: 'warning'
                })
                return
            }
            let permsIds = checkedNodes.map(item => {
                return item.id
            })
            const params = {
                id: this.$route.query.id,
                name: this.formData.name.trim(),
                enabled: this.formData.enabled,
                remark: this.formData.remark,
                permsIds
            }
            this.disabled = true;
            updateRole(params).then((res) => {
                this.disabled = false;
                if (Number(res.code) === 20000) {
                    // 返回
                    this.goBackHandle()
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch((err) => {
                this.disabled = false;
                this.$message.error(err);
            });
        },
        // 返回
        goBackHandle () {
            this.$router.go(-1)
        }
    },
    // 创建完成
    created () {

    },
    // 挂载完成
    mounted () {
        // 判断是否获取详情
        if (this.$route.query.id) {
            this.getDetails()
        } else {
            // 获取权限树
            this.getPermissionTree()
        }
    },
    // 销毁之前
    beforeDestroy () {
    }
};
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    .container-main {
        width: 60%;
        flex-grow: 1;
        padding-bottom: 20px;
        .card {
            margin-top: 20px;
            width: 100%;
            background: #ffffff;
            .card-title {
                height: 60px;
                display: flex;
                align-items: center;
                .square {
                    display: inline-block;
                    width: 4px;
                    height: 30px;
                    background-color: #409eff;
                    border-radius: 2px;
                }
                .text {
                    margin-left: 20px;
                    font-size: 16px;
                }
            }

            .card-content {
                padding: 20px;
                display: flex;
                justify-content: center;
                ::v-deep .el-form {
                    width: 560px;
                }
                ::v-deep .el-tree {
                    min-width: 560px;
                }
            }
        }
    }
    .container-footer {
        width: 100%;
        height: 60px;
        flex-shrink: 0;
        background-color: #fff;
        display: flex;
        align-items: center;
        .handle {
            width: 100%;
            display: flex;
            justify-content: space-around;
        }
    }
}
</style>
